import { http } from "./http";

export const quickSearchApi = {
  searchRegrid: (parcelNumber) =>
    http
      .get("/quick-search/regrid", {
        params: { parcel_number: parcelNumber },
      })
      .then((response) => response.data.data),

  getRegridParcelDetails: (llUuid) =>
    http
      .get(`/quick-search/regrid/${llUuid}`)
      .then((response) => response.data.data),

  getCountyResources: ({ stateCode, county }) =>
    http
      .get("/quick-search/county-resources", {
        params: { state_code: stateCode, county },
      })
      .then((response) => response.data.data),

  previewCensus: ({ latitude, longitude }) =>
    http
      .post("/quick-search/census", { latitude, longitude })
      .then((response) => response.data.data),

  previewGooglePlaces: ({ latitude, longitude }) =>
    http
      .post("/quick-search/google-places", { latitude, longitude })
      .then((response) => response.data.data),
};
